import { useContext } from 'react';
import { TableCalculationsContext } from '../TableCalculationsContext';

export const useTableCalculations = () => {
  const context = useContext(TableCalculationsContext);
  if (!context) {
    throw new Error('useTableCalculations must be used within a TableCalculationsProvider');
  }
  return context;
};